import { useState, forwardRef } from "react";
import Modal from "../../../utils/components/Modal";
import Button from "../../../utils/components/Button";
import SelectBox from "../../../utils/components/SelectBox";
import Textarea from "../../../utils/components/Textarea";
import Checkbox from "../../../utils/components/Checkbox";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { confirmAlert } from "react-confirm-alert";
import AlertModal from "../../../utils/components/AlertModal";
import API from "../../../utils/API";
import { getUnixTime } from "date-fns";
import { useNavigate } from "react-router";
import { auth } from "../../../App/routes";
import { useEffect } from "react";
import DataTable from "../../../utils/components/DataTable";
import { Translate } from "react-localize-redux";

const PersonsList = ({
  users,
  groups,
  companies,
  translate,
  selectedOnes,
  excludeOnes = [],
  key,
}) => {
  const isNotExcluded = (userId) =>
    excludeOnes.findIndex((u) => u.value === userId) < 0;

  return [
    {
      label: translate("users"),
      options: users
        .filter((user) =>
          key === "discipline" ? user.isActionUser : user.isInfoUser
        )
        .filter((user) => isNotExcluded(user.value))
        .map((user) => ({ ...user, type: "user" })),
    },
    {
      label: translate("groups"),
      options: groups
        .map((group) => {
          const users = group.users
            .filter((user) =>
              key === "discipline" ? user.isActionUser : user.isInfoUser
            )
            .filter((user) => isNotExcluded(user.id));

          return { ...group, users };
        })
        .filter((group) => {
          const users = group.users.filter(
            (user) =>
              selectedOnes.findIndex(
                (selectedUser) => selectedUser.value === user.id
              ) < 0
          );

          return users.length > 0;
        })
        .map(({ value, label, secLabel }) => ({
          value,
          label,
          type: "group",
          secLabel,
        })),
    },
    {
      label: translate("companies-uppercase"),
      options: companies
        .filter((company) => {
          const users = company.users.filter(
            (user) =>
              selectedOnes.findIndex(
                (selectedUser) => selectedUser.value === user.id
              ) < 0 && isNotExcluded(user.id)
          );

          return users.length > 0;
        })
        .map(({ value, label }) => ({
          value,
          label,
          type: "company",
        })),
    },
  ];
};

const dateTypeFormat = {
  name: "Full Date",
  format: "dd/MM/yyyy",
  showMonthYearPicker: false,
  showTimeSelect: false,
};
const columns = [
  {
    name: <Translate id="forms.headers.form_name" />,
    selector: (row) => row.formName,
    cell: (row) => (
      <div className="d-flex flex-column align-items-start">
        <span>{row.no}</span>
        <span className="text-gray">{row.formName}</span>
      </div>
    ),
  },
  {
    name: <Translate id="forms.headers.status" />,
    selector: (row) => row.status,
    compact: true,
  },
  {
    name: <Translate id="forms.headers.created_by" />,
    selector: (row) => row.createdBy,
  },
  {
    name: <Translate id="forms.headers.location" />,
    selector: (row) => row.location,
  },
];

const PersonsSelectBox = ({
  translate,
  options,
  value,
  onChange,
  title,
  placeholder,
}) => {
  return (
    <div className="col-12 my-3">
      <p className="fw-bold fs-6 text-uppercase text-secondary mb-2">{title}</p>
      <SelectBox
        options={options}
        isMulti={true}
        closeMenuOnSelect={false}
        value={value}
        onChange={(selectedUsers, action) => onChange(selectedUsers, action)}
        placeholder={placeholder}
      />
    </div>
  );
};

const NewTaskAssignmentModal = ({
  show,
  hideModal,
  users = [],
  companies = [],
  groups = [],
  formId: form_id,
  forms = [],
  translate,
  handleSaveForm = null,
}) => {
  const [taskType, setTaskType] = useState(1);
  const [isAnswerRequired, setIsAnswerRequired] = useState(false);
  const [pickerDate, setPickerDate] = useState(new Date());
  const [selectedDiscipline, setSelectedDiscipline] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [dateType] = useState(dateTypeFormat);
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);

  const DateCustomInput = forwardRef(({ value, onClick, headTitle }, ref) => (
    <button className="card px-5" onClick={onClick} ref={ref}>
      <span
        style={{
          position: "relative",
          marginTop: "-10px",
        }}
        className="title text-secondary bg-white mb-0 px-2 fw-bold"
      >
        {headTitle}
      </span>
      <span className="mb-0 ps-2 py-2">{value}</span>
    </button>
  ));

  useEffect(() => {
    if (!show) {
      setTaskType(1);
      setIsAnswerRequired(false);
      setPickerDate(new Date());
      setSelectedDiscipline([]);
      setSelectedUsers([]);
      setDescription("");
      setIsSending(false);
    }
  }, [show]);

  const handleSubmit = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    const requiredFields = [
      {
        validation:
          (taskType === 1 && selectedDiscipline.length > 0) || taskType === 2,
        message: "Göreve atanan kişi seçimi yapılmalı.",
      },
      {
        validation: (isAnswerRequired && pickerDate) || !isAnswerRequired,
      },
    ];

    if (failedValidation(requiredFields)) {
      return;
    }

    const payload = {
      action_users: selectedDiscipline.map((user) => user.value),
      description,
      info_users: selectedUsers.map((user) => user.value),
      step_no: 0,
      type: taskType === 1 ? "task" : "response",
    };

    if (forms.length) payload.form_ids = forms.map((form) => form.id);
    else payload.form_id = form_id;

    if (isAnswerRequired) payload.due_date = getUnixTime(pickerDate);

    if (handleSaveForm) handleSaveForm(payload, "task");
    else {
      const url = forms?.length ? "tasks/multiple" : "tasks";
      API.postData(url, payload)
        .then(({ data: res }) => {
          if (!forms?.length) {
            navigate(auth.formBoxDetails.link.replace(":id", res.data.id));
            hideModal("send");
          } else {
            if (res.data.fail_form_id?.length) {
              hideModal(res.data.fail_form_id);
            } else {
              hideModal("success");
            }
          }

          setIsSending(false);
        })
        .catch(() => {
          setIsSending(false);
        });
    }
  };

  const failedValidation = (required) => {
    return required.some((field) => {
      if (!field.validation) {
        confirmAlert({
          customUI: ({ onClose }) => (
            <AlertModal
              buttons={[
                {
                  label: translate("okay"),
                  onClick: onClose,
                  classNames: "btn btn-primary",
                },
              ]}
              message={field.message}
            />
          ),
        });
        return true;
      }

      return false;
    });
  };

  const handleAddUsers = (type, option, selectType) => {
    const selected =
      selectType === "discipline" ? selectedDiscipline : selectedUsers;
    const setSelected =
      selectType === "discipline" ? setSelectedDiscipline : setSelectedUsers;
    const otherSelected =
      selectType === "discipline" ? selectedUsers : selectedDiscipline;

    const isNotInOther = (userId) =>
      otherSelected.findIndex((u) => u.value === userId) < 0;

    if (type === "company") {
      const company = companies.find(
        (company) => company.value === option.value
      );

      const companyUsers = company.users.filter(
        (user) =>
          selected.findIndex((selectedUser) => selectedUser.value === user.id) <
            0 &&
          isNotInOther(user.id)
      );

      setSelected([
        ...selected,
        ...companyUsers.map((user) => ({ value: user.id, label: user.name })),
      ]);
    } else if (type === "user") {
      setSelected([...selected, option]);
    } else if (type === "group") {
      const group = groups.find((group) => group.value === option.value);

      const groupUsers = group.users
        .filter((user) =>
          selectType === "discipline" ? user.isActionUser : user.isInfoUser
        )
        .filter(
          (user) =>
            selected.findIndex(
              (selectedUser) => selectedUser.value === user.id
            ) < 0 &&
            isNotInOther(user.id)
        );

      setSelected([
        ...selected,
        ...groupUsers.map((user) => ({ value: user.id, label: user.name })),
      ]);
    }
  };

  return (
    <Modal
      title={translate("forms.new-task-assignment-modal.new-task")}
      positiveButtonNode={translate("send")}
      negativeButtonNode={translate("cancel")}
      positiveButtonHandler={handleSubmit}
      modalSize="lg"
      show={show}
      setShow={hideModal}
      disableButtons={isSending}
    >
      <div className="row">
        <div className="col-12 my-3 text-center">
          <Button
            className={`${
              taskType === 1 ? "btn-orange text-white" : "btn-secondary"
            }`}
            onClick={() => {
              setTaskType(1);
            }}
          >
            {translate("forms.new-task-assignment-modal.as-assignment")}
          </Button>
          <Button
            className={`${
              taskType === 2 ? "btn-orange text-white" : "btn-secondary"
            }`}
            onClick={() => {
              setTaskType(2);
            }}
          >
            {translate("forms.new-task-assignment-modal.in-reply-to")}
          </Button>
        </div>
        {taskType === 1 && (
          <PersonsSelectBox
            translate={translate}
            options={PersonsList({
              users,
              groups,
              companies,
              translate,
              selectedOnes: selectedDiscipline,
              excludeOnes: selectedUsers,
              key: "discipline",
            })}
            value={selectedDiscipline}
            onChange={(selectedDiscipline, action) => {
              if (action)
                if (`option` in action) {
                  handleAddUsers(
                    action.option.type,
                    action.option,
                    "discipline"
                  );
                } else setSelectedDiscipline(selectedDiscipline);
            }}
            placeholder={translate(
              "forms.new-task-assignment-modal.placeholders.search-person"
            )}
            title={translate(
              "forms.new-task-assignment-modal.appointed-person"
            )}
          />
        )}
        <PersonsSelectBox
          translate={translate}
          options={PersonsList({
            users,
            groups,
            companies,
            translate,
            selectedOnes: selectedUsers,
            excludeOnes: selectedDiscipline,
            key: "info",
          })}
          value={selectedUsers}
          onChange={(selectedUsers, action) => {
            if (`option` in action) {
              handleAddUsers(action.option.type, action.option, "info");
            } else setSelectedUsers(selectedUsers);
          }}
          placeholder={translate(
            "forms.new-task-assignment-modal.placeholders.search-person"
          )}
          title={translate("forms.new-task-assignment-modal.for-information")}
        />

        <div className="col-12 my-3">
          <p className="fw-bold fs-6 text-uppercase text-secondary mb-2">
            {translate("forms.new-task-assignment-modal.message")}
          </p>
          <Textarea
            className="textarea"
            placeholder={translate(
              "forms.new-task-assignment-modal.placeholders.task-description"
            )}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div className="col-12 d-flex align-items-center justify-content-around my-4">
          {taskType === 1 && (
            <div>
              <Checkbox
                id="checkbox"
                className="mr-2"
                label={translate(
                  "forms.new-task-assignment-modal.placeholders.answer-required"
                )}
                checked={isAnswerRequired}
                onChange={() => setIsAnswerRequired(!isAnswerRequired)}
                disabled={false}
              />
            </div>
          )}
          <div className={`${isAnswerRequired ? "visible" : "invisible"}`}>
            <DatePicker
              selected={pickerDate}
              dateFormat={dateType.format}
              showMonthYearPicker={dateType.showMonthYearPicker}
              showTimeSelect={dateType.showTimeSelect}
              onChange={(date) => setPickerDate(date)}
              customInput={
                <DateCustomInput
                  headTitle={translate(
                    "forms.new-task-assignment-modal.placeholders.due-date"
                  )}
                />
              }
              minDate={new Date()}
            />
          </div>
        </div>
      </div>
      {forms.length > 0 && (
        <div className="row">
          <div className="col-12">
            <DataTable columns={columns} data={forms} />
          </div>
        </div>
      )}
    </Modal>
  );
};
export default NewTaskAssignmentModal;
